<template>
  <div class="mobile-phone">
    <router-link to="/navigate">
      <div class="return-arrow">
        <i class="el-icon-arrow-left"></i>
      </div>
    </router-link>
    <baidu-map class="baidu-map" :center="center" :zoom="zoom" @ready="handler">
      <bm-boundary :name=mapBoundary :strokeWeight="3" fillColor="" strokeColor="blue"></bm-boundary>
      <bm-view :class="{ 'bm-view-full': !showNavigation, 'bm-view-half': showNavigation }" :center="center" :zoom="zoom"></bm-view>
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <bm-marker :position="myLocation">
        <bm-label content="我的位置" :labelStyle="{color: 'red', fontSize: '16px'}" :offset="{width: -25, height: 30}" :zIndex="2"/>
      </bm-marker>
      <bm-marker v-for="(item, index) in markerPoints" :key="index" :position="item" @click="onMarkerClick(index)">
        <bm-info-window :show="item.show" @open="onMarkerClick(index)" @close="closeMarkerClick(index)">
          <div>
            <div class="title-wrapper">
              <h4 class="facility-name">{{ item.facilityName }}</h4>
              <div class="business-status-box" :class="{ 'open': item.isBusinessHours , 'closed': !item.isBusinessHours }">
                {{ item.isBusinessHours ? '营业中' : '休息中' }}
              </div>
              <i v-if="item.title && item.content" class="el-icon-document facility-speaker" @click="showFacilityNotice(item)"></i>
            </div>
            <p class="facility-address" @click="handleCopyAddressClick(item.facilityAddress)"><i class="el-icon-location-outline"></i>{{ item.facilityAddress }}<i class="el-icon-document-copy icon-color"></i></p>
            <p class="facility-time"><i class="el-icon-time"></i>上午{{ item.amTime }}  下午{{ item.pmTime }}</p>
            <div class="facility-service">
              <div class="service" v-if="item.hasSelfQuery === 'Y'">
                <div class="icon-div">
                  <img src="../assets/icon_per.png" class="icon-img">
                  <span>个人查询服务</span>
                </div>
              </div>
              <div class="service" v-if="item.hasMulitpleId === 'Y'">
                <div class="icon-div">
                  <img src="../assets/icon_per_hk.png" class="icon-img">
                  <span>个人查询服务(支持港澳台)</span>
                </div>
              </div>
              <div class="service" v-if="item.hasEnterQuery === 'Y'">
                <div class="icon-div">
                  <img src="../assets/icon_ent.png" class="icon-img">
                  <span>企业查询服务</span>
                </div>
              </div>
              <div class="service" v-if="item.hasSmartMachine === 'Y'">
                <div class="icon-div">
                  <img src="../assets/icon_smart.png" class="icon-img">
                  <span>商业银行智慧柜员机</span>
                </div>
              </div>
            </div>
            <div class="button-div">
              <el-button size="mini" @click="showBusNavigationButton(item)">公交去这里</el-button>
              <el-button size="mini" @click="showWalkingNavigationButton(item)">步行去这里</el-button>
            </div>
          </div>
        </bm-info-window>
      </bm-marker>
      <bm-transit v-if="showNavigation && showBusNavigation" :start="start" :end="end" :auto-viewport="true" @searchcomplete="handleBusRouteSearchComplete"></bm-transit>
      <bm-walking v-if="showNavigation && showWalkingNavigation" :start="start" :end="end" :auto-viewport="true" @searchcomplete="handleWalkingSearchComplete"></bm-walking>
    </baidu-map>
    <el-dialog
      title="通知及公告"
      :visible.sync="isNoticeDialogVisible"
      @close="isNoticeDialogVisible = false"
      width="90%"
    >
      <div class="dialog-content">
        <h4 class="notice-title" v-html="currentFacilityNotice.title || ''"></h4>
        <div v-html="currentFacilityNotice.content || ''"></div>
      </div>
      <div class="divider"></div>
      <span slot="footer">
        <el-button class="confirm-button" @click="isNoticeDialogVisible = false" size="small">
           确定
        </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
export default {
  name: 'Map.vue',
  data () {
    return {
      markerPoints: [],
      center: { lng: 119.307605, lat: 26.072032 },
      mapBoundary: '福建省',
      zoom: 13,
      start: '',
      end: '',
      myLocation: { lng: null, lat: null },
      showNavigation: false,
      showBusNavigation: false,
      showWalkingNavigation: false,
      selectedFacility: null,
      isNoticeDialogVisible: false,
      currentFacilityNotice: {
        title: '',
        content: ''
      }
    }
  },
  methods: {
    handler ({ BMap, map }) {
      this.lng = 116.404
      this.lat = 39.915
      this.zoom = 13
    },
    handleCopyAddressClick (address) {
      const tempElement = document.createElement('button')
      tempElement.setAttribute('data-clipboard-text', address)
      // 将临时元素添加到文档中
      this.$el.appendChild(tempElement)
      // 初始化 ClipboardJS
      const clipboard = new ClipboardJS(tempElement)
      // 触发点击事件，复制文本到剪贴板
      tempElement.click()
      // 在完成后销毁 ClipboardJS 实例和临时元素
      clipboard.destroy()
      this.$el.removeChild(tempElement)
      this.$alert('成功复制地址', '征信查询向导')
    },
    onMarkerClick (index) {
      this.openIndex = index
      this.$set(this.markerPoints, index, { ...this.markerPoints[index], show: true })
    },
    closeMarkerClick (index) {
      this.$set(this.markerPoints, index, { ...this.markerPoints[index], show: false })
    },
    showBusNavigationButton (item) {
      this.showNavigation = true
      this.showBusNavigation = true
      this.showWalkingNavigation = false
      this.selectedFacility = item
      const locationArray = this.location.split(',')
      this.start = { lng: parseFloat(locationArray[0]), lat: parseFloat(locationArray[1]) }
      this.end = { lng: parseFloat(item.lng), lat: parseFloat(item.lat) }
    },
    showWalkingNavigationButton (item) {
      this.showNavigation = true
      this.showBusNavigation = false
      this.showWalkingNavigation = true
      this.selectedFacility = item
      const locationArray = this.location.split(',')
      this.start = { lng: parseFloat(locationArray[0]), lat: parseFloat(locationArray[1]) }
      this.end = { lng: parseFloat(item.lng), lat: parseFloat(item.lat) }
    },
    handleBusRouteSearchComplete (result) {
      if (result.getPlan(0) === undefined) {
        this.showNavigation = false
        this.$alert('不支持此种出行方式，请选择其他方式', '征信查询向导')
      }
    },
    handleWalkingSearchComplete (result) {
      if (result.getPlan(0) === undefined) {
        this.showNavigation = false
        this.$alert('未找到步行路线，请选择其他方式', '征信查询向导')
      }
    },
    showFacilityNotice (facility) {
      this.currentFacilityNotice.title = facility.title
      this.currentFacilityNotice.content = facility.content
      this.isNoticeDialogVisible = true
    }
  },
  created () {
    this.facilityList = this.$route.params.facilityList
    this.location = this.$route.params.location
    this.myLocation.lng = this.$route.params.location.split(',')[0]
    this.myLocation.lat = this.$route.params.location.split(',')[1]
    if (this.$route.params.center) {
      this.center = this.$route.params.center
    }
    for (const i in this.facilityList) {
      const markerPoint = { id: null, lng: null, lat: null, facilityName: null, facilityAddress: null, show: false }
      markerPoint.id = this.facilityList[i].id
      markerPoint.lng = this.facilityList[i].longitude.split(',')[0]
      markerPoint.lat = this.facilityList[i].longitude.split(',')[1]
      markerPoint.facilityName = this.facilityList[i].facilityName
      markerPoint.facilityAddress = this.facilityList[i].facilityAddress
      markerPoint.amTime = this.facilityList[i].amTime
      markerPoint.pmTime = this.facilityList[i].pmTime
      markerPoint.title = this.facilityList[i].title
      markerPoint.content = this.facilityList[i].content
      markerPoint.isBusinessHours = this.facilityList[i].isBusinessHours
      markerPoint.hasEnterQuery = this.facilityList[i].hasEnterQuery
      markerPoint.hasMulitpleId = this.facilityList[i].hasMulitpleId
      markerPoint.hasSelfQuery = this.facilityList[i].hasSelfQuery
      markerPoint.hasSmartMachine = this.facilityList[i].hasSmartMachine
      this.markerPoints.push((markerPoint))
    }
  }
}
</script>

<style scoped>
.mobile-phone {
  background-color: #f1f1f1;
  height: 100vh;
  margin: 0;
}

.baidu-map {
  width: 100%;
  height: 100%;
}

.bm-view-full {
  width: 100%;
  height: 100%;
}

.bm-view-half {
  width: 100%;
  height: 50%;
}

.facility-address {
  color: #999;
  font-size: 13px;
}

.facility-time {
  margin: 0;
  padding-bottom: 5px;
  font-size: 12px;
  color: #a3a3a3;
}
::v-deep .anchorBL {
  display: none !important;
}

.title-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  font-size: 16px;
}

.facility-name {
  margin: 0;
  font-weight: 400;
  font-size: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.facility-speaker {
  font-size: 16px;
  color: #b22d32;
  cursor: pointer;
  margin-left: 5px;
  align-self: center;
}

.notice-title {
  text-align: center;
}

::v-deep .el-dialog__body {
  padding: 0 20px 10px 20px !important;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #b22d32;
  margin: 0 20px;
  padding: 20px 0 10px 0;
}

.dialog-content {
  height: 480px;
}
::v-deep .el-dialog__footer {
  text-align: center !important;
}

.confirm-button {
  color: #b22d32;
}

.icon-color {
  color: black;
}

.business-status-box {
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 14px;
  margin-left: 5px;
  white-space: nowrap;
}

.open {
  background-color: #2696e8;
  color: white;
}

.closed {
  background-color: #e1e1e1;
  color: #888888;
}

.facility-service {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
}

.service {
  padding: 3px 0;
  margin-right: 2px;
  font-size: 12px;
}

.icon-img {
  max-height: 15px;
  max-width: 15px;
}

.icon-div {
  color: #2696e8;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button-div {
  padding-top: 5px;
  display: flex;
  text-align: center;
}

.return-arrow {
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;
  font-size: 20px;
  color: #888888;
  z-index: 99;
}
</style>
